<div
  style="background: url('../../../../assets/images/Landing/bg-mobile-fallback.jpg')"
  class="!tw-bg-no-repeat tw-h-screen !tw-bg-cover">
  <div class="masthead">
    <div class="masthead-content text-white">
      <div class="container-fluid px-4 px-lg-0">
        <h1 class="tw-font-outfit tw-text-[100px] mb-4 !tw-text-white">This Page Is Under Development</h1>
        <p class="mb-5 !tw-text-white">We're currently working on this page. Please check back soon!</p>
      </div>
    </div>
  </div>
  <!-- Social Icons-->
  <div class="social-icons">
    <div class="d-flex flex-row flex-lg-column justify-content-center align-items-center h-100 mt-3 mt-lg-0">
      <a class="btn btn-dark m-3" href="#!"><i class="fa-brands !tw-text-white fa-twitter"></i></a>
      <a class="btn btn-dark m-3" href="#!"><i class="fab !tw-text-white fa-facebook-f"></i></a>
      <a class="btn btn-dark m-3" href="#!"><i class="fab !tw-text-white fa-instagram"></i></a>
    </div>
  </div>
</div>
